import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TimelineService } from '../../../../core/services/timeline.service';
import { ReportsService } from '../../../../core/services/reports.service';
import { TimelineContainer } from '../../../../core/models/timeline-container.model';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-container-report-detail',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatCardModule, RouterModule],
  templateUrl: './container-report-detail.component.html',
  styleUrls: ['./container-report-detail.component.scss'],
})
export class ContainerReportDetailComponent implements OnInit {
  maintenanceRecordId!: number;
  header: any = null;
  events: any[] = [];
  expandedEventIndex: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private timelineService: TimelineService,
    private reportsService: ReportsService,
  ) {}

  ngOnInit(): void {
    this.maintenanceRecordId = +this.route.snapshot.paramMap.get('maintenanceRecordId')!;
    this.loadMaintenanceRecordDetail();
  }

  private toDataUrl(b64: string): string {
    // Evita prefijar dos veces si ya viene con data:
    return b64.startsWith('data:') ? b64 : `data:image/jpeg;base64,${b64}`;
  }

  loadMaintenanceRecordDetail(): void {
  this.timelineService
    .getMaintenanceRecordEvents(this.maintenanceRecordId)
    .subscribe((data: TimelineContainer) => {

      this.header = data.header;

      this.events = data.timeline.map(evt => ({
        title: evt.title ?? evt.title ?? 'Sin título',
        timestamp: new Date(evt.timestamp ?? evt.timestamp),
        state: evt.state ?? evt.state,
        observations: evt.observations ?? evt.observations,

        image: Array.isArray(evt.image ?? evt.image)
          ? (evt.image ?? evt.image)
              .filter(img => !!img && img !== 'Sin Fotos')
              .map(this.toDataUrl)
          : [],
      }));
    });
}


  toggleEventDetails(index: number): void {
    if (this.expandedEventIndex === index) {
      this.expandedEventIndex = null;
    } else {
      this.expandedEventIndex = index;
    }
  }

  exportPdf(): void {
    if (!this.header?.container?.id) {
      return;
    }
    const containerId = this.header.container.id;
    this.reportsService.getReportContainerDetailPdf(containerId).subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `container_report_${containerId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
}
